import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { createUpdateIdentity, UserIdentityApiParameter } from "@TKCCP/Services/PunchoutIdentityService";
import { UserIdentityCollection, UserIdentityModel } from "@TKCCP/Types/ApiModels";

// type UserIdentityParameter1 = UserIdentityCollection & HasOnSuccess<boolean>;
type UserIdentityParameter1 = {
    onError?: (error: string) => void;
} & UserIdentityApiParameter &
    HasOnSuccess<boolean>;

type HandlerType = ApiHandler<UserIdentityParameter1, boolean>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await createUpdateIdentity(props.apiParameter);

    // if (result.successful) {
    //     props.apiResult = result.result;
    // } else {
    //     if (result.statusCode === 403) {
    //         const { isAuthenticated, rememberMe } = props.getState().context.session;
    //         (isAuthenticated || rememberMe) && window.location.reload();
    //         return false;
    //     }

    //     props.parameter.onError?.(result.errorMessage);
    //     return false;
    // }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    // markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const addUpdatePunchoutUserIdentity = createHandlerChainRunner(chain, "AddUpdatePunchoutUserIdentity");
export default addUpdatePunchoutUserIdentity;
